module.exports = __webpack_public_path__ + "static/breast_cancer-19cc4182616effccef7b08896068e5c8.pdf";